const locale = {
  assistLabel: 'You may enter:'
};
export default locale;